import { render } from "./videoDellaSettimanaViewer.vue?vue&type=template&id=32b92a2c&ts=true"
import script from "./videoDellaSettimanaViewer.vue?vue&type=script&lang=ts"
export * from "./videoDellaSettimanaViewer.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__